import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import ErrorView from 'scoreboard/components/error-view'
import Slider from 'scoreboard/components/slider'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import formatValue from 'scoreboard/components/format-value'
import enums from 'scoreboard/components/enums'
import momentHelper from 'scoreboard/components/moment-helper'
import config from 'scoreboard/components/config'
import license from 'scoreboard/components/license'
import template from './background-processes.hbs'
import itemTemplate from './background-process-item.hbs'
import UnprocessedOperations from './unprocessed-operations'
import UnprocessedScorecards from './unprocessed-scorecards'
import DisplayHeader from 'scoreboard/components/display-header'
import BusyButton from 'scoreboard/components/busy-button'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, PERCENT } = DataType


var BackgroundProcessStatus = Backbone.View.extend({

	className: 'admin table-hack display-layout background-process-status',

	events: {
		'click .banner-error': 'showStackTrace',
		'click .reactivate': 'reactivateReplication',
		'click [data-key="admin.backgroundProcessStatus.unprocessedCommands"] .value': 'onUnprocessedOperations',
		'click [data-key="admin.backgroundProcessStatus.percentWeighting.uncalculatedScorecards"] .value': 'onUnprocessedScorecards'
	},

	// Backbone Functions

	/**
	 * @param options
	 * @param options.data.statuses is a hash of the enumeration of all statuses
	 * in which the key correlates to global.enums.backgroundProcess
	 */
	initialize: function(options) {
		this.options = options || {}
		this.data = options.data

		this.processes = _.forEach(this.data.statuses, function(statusDetails, processKey){
			enrichStatusDetails(statusDetails, processKey)
		}.bind(this))

		this.memory = this.data.memoryStatus
	},

	render: function() {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.backgroundProcessStatus'),
			mobileGearHidden: true
		}).render().el, template(this))

		this.sliders = []
		this.$('input[type=number]').each(function(index, el) {
			this.sliders.push(new Slider({
				input: el,
				roundedValue: false,
				unit: 'GB'
			}).render())
		}.bind(this))

		const col1 = ['score-calc', 'percent-weighting']
		const col2 = []
		if (license.datasets) {
			col1.push('datasets')
			col1.push('dataset-metrics')
			col1.push('datasets-query-cache-refresher')
		}

		col2.push('template-command')
		config.replicationEnabled && col2.push('replication')
		col2.push('deletion')
		col2.push('export-generation')

		// #33050 display alert thread status
		col1.push('alert-notification')

		this._addItems('.background-process-col1', col1)
		this._addItems('.background-process-col2', col2)

		this.$('[data-key="admin.backgroundProcessStatus.unprocessedCommands"] .value span')
			.addClass('text-link-emphasized')
		this.$('[data-key="admin.backgroundProcessStatus.percentWeighting.uncalculatedScorecards"] .value span')
			.addClass('text-link-emphasized')

		// Remove extra attributes if the value is 0
		// https://github.com/SpiderStrategies/Scoreboard/issues/24189#issuecomment-510734133
		this.$('.status-group-row[data-value=0]').remove()

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.sliders, 'remove')
		this.reactivateButton && this.reactivateButton.remove()
	},

	//Rendering

	_addItems: function(className, items) {
		var html = ''
		_.each(items, function (i) {
			if (_.has(this.processes, i)) {
				let repDeactivated = this.processes[i].statusCode == 'admin.replicationStatus.suspended'
				html += itemTemplate({id:i, data: this.processes[i], repDeactivated})
			}
		}.bind(this))
		this.$(className).html(html)

		let reactivate = this.$('.reactivate')
		if (reactivate.length) {
			this.reactivateButton = new BusyButton({ el: reactivate[0] })
		}
	},

	//Events

	showStackTrace: function(e) {
		var process = $(e.target).closest('[data-process]').data('process')
		var dbHealth = this.processes[process].dbHealth
		appDisplay.dialog(new ErrorView({
			message: dbHealth.errorLastMessage,
			stackTrace: dbHealth.errorLastThrowable
		}))
	},

	reactivateReplication: function(e) {
		if (this.reactivateButton.state != 'ready') return

		this.reactivateButton.loading()
		$.post({
			url: 'api/background/replication/reactivate',
			success: () => {
				this.reactivateButton.done()
			}
		}).fail(() => {
			this.reactivateButton.enable()
		})
	},

	onUnprocessedOperations: function(e) {
		let process = this.$(e.target).closest('[data-process]').data('process')
		let url = `api/admin/background-processes/unprocessed-operations/${process}`
		appDisplay.dialog($.get(url), unprocessed =>
			new UnprocessedOperations({ unprocessed }))
	},

	onUnprocessedScorecards: function(e) {
		let url = `api/admin/background-processes/unprocessed-scorecards`
		appDisplay.dialog($.get(url), unprocessed =>
			new UnprocessedScorecards({ unprocessed }))
	}

})

function enrichStatusDetails(statusDetails, processKey) {
	statusDetails.labelKey = enums.backgroundProcess[processKey]
	statusDetails.descriptionKey = statusDetails.labelKey + '.description'
	var metrics = statusDetails.metrics
	var lastErrKey = 'admin.backgroundProcessStatus.lastErrTime'
	if (_.isNull(metrics[lastErrKey])) {
		metrics[lastErrKey] = i18n.get('common.none')
	} else {
		metrics[lastErrKey] = momentHelper.formatDateTime(metrics[lastErrKey])
	}
	enrichAttributes(statusDetails.attributes)
	enrichAttributes(metrics) // to format "errors last *" messages
}

/**
 * If there are attributes for a metric, enrich them accordingly
 * @param attr may be undefined
 * @private
 */
function enrichAttributes(attr) {
	var pctKey = 'admin.backgroundProcessStatus.percentageComplete'
	if (attr && _.isNumber(attr[pctKey])) {
		attr[pctKey] = formatValue({
			value: attr[pctKey],
			dataType: PERCENT
		})
	}
	// issue #11308 format numbers with commas
	var fmtNumberKeys =
		['admin.backgroundProcessStatus.uncalculatedScores', 'admin.backgroundProcessStatus.unprocessedCommands',
			'admin.backgroundProcessStatus.errLastHour',
			'admin.backgroundProcessStatus.errLastSixHours', 'admin.backgroundProcessStatus.errLast24Hours',
			'admin.backgroundProcessStatus.percentWeighting.uncalculatedScorecards']
	_.each(fmtNumberKeys, function (key) {
		if (attr && attr[key]) {
			attr[key] = formatValue({
				value: attr[key],
				dataType: NUMBER,
				shorten: false
			})
		}
	})

	// #27314 format backlog time as duration
	var backlogKey = 'admin.backgroundProcessStatus.backlog'
	if (attr && attr[backlogKey]) {
		attr[backlogKey] = momentHelper.fromNow(attr[backlogKey], true)
	}
}



//Exposed for testing
const enrichMetrics = enrichStatusDetails
_.extend(BackgroundProcessStatus, { enrichMetrics, enrichAttributes })

export default BackgroundProcessStatus
export { enrichMetrics }
export { enrichAttributes }

BackgroundProcessStatus.__filename__ = 'admin/background-processes/background-processes.js'
